exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-content[data-v-184ee470]{height:calc(100vh - 0.4375rem - 0.28125rem - 0.36458rem)}.body-content .bm-view[data-v-184ee470]{width:100%;height:100%}.body-content .bm-view[data-v-184ee470] .BMap_Marker img{width:100%;height:100%;object-fit:contain}\n", ""]);

// exports
